import { RectLoadingBar } from "../../components/LoadingBar/FullScreenLoadingBar";


export type FullScreenLoadingProps = { isLoading: boolean; testId?: string, transparent?:boolean };

export default function useFullScreenLoading({ isLoading, testId, transparent = false }: FullScreenLoadingProps) {

  if (!isLoading)
    return null;

  return (
    <div
      className={`fixed inset-0 z-[60] flex justify-center items-center transition-all ${transparent ? "" : "bg-black bg-opacity-30 " } ` }
      data-testid={`${testId}-full-screen-loading`}
    >
      <RectLoadingBar isLoading={isLoading} />
    </div>
  );
}
